/**
 * InteractiveGuide Articles container
 * Displaying the articles when user selected the ICF
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import _find from 'lodash/find';
import { Link } from 'react-router-dom';

import * as shapes from '../constants/PropTypesShapes';
import { expandFAQContent, setICFAccessArticle } from '../actions/action-icf-page';
import * as Page from '../../lib/page';
import { downArrow, upArrow, check } from '../../lib/svgImages';
import { trackLink } from '../../lib/analytics-helper';
import l10n from '../../lib/reactPPl10nHelper';

const icf = {
  articles: {
    backBtn: l10n.getContent('smarthelp/home.home.back.icf.articles'),
  },
};

class icfArticlesContainer extends Component {
  // To form faq link for by FAQ id of solutionLink in the content
  static handleFAQClick(event) {
    const target = event.target;
    const faqID = target.id;

    if (faqID && target.name === 'solutionLink') {
      event.preventDefault();
    }
  }

  static handleKeyPress(event) {
    if (event.which === 13) {
      icfArticlesContainer.handleFAQClick();
    }
  }

  // Get expansion article content style; hide/display the article content
  static getGuideArticleContainerStyle() {
    return classNames({
      'accordion-guide-article-container': true,
    });
  }

  constructor(props) {
    super(props);
    this.renderIcfArticles = this.renderIcfArticles.bind(this);
    this.backToHome = this.backToHome.bind(this);
  }

  // using current ICF id to find the current ICF page defail from the list of ICF
  getCurrentICFContent() {
    return _find(this.props.icfList, icfContent => icfContent.icf_id === this.props.currentIcfId);
  }

  // using current ICF id to find the current ICF page defail from the list of ICF
  keyPressHandler(event, articleId) {
    if (event.which === 13) {
      this.expandHandler(articleId);
    }
  }

  // Click event when user click bullet point or one of the FAQ item
  expandHandler(articleId) {
    trackLink({ id: 'ICFPage', link: `icf-expansion|click|${articleId}`, name: 'homePage', hpid: `${this.props.currentIcfId}` });
    const accessedICFArray = this.props.accessedList && this.props.accessedList.filter(ele => ele.icfId === this.props.currentIcfId);

    // if there is no such entry add it
    if (Array.isArray(this.props.accessedList) && !accessedICFArray.length) {
      this.props.setICFAccessArticle(this.props.currentIcfId, articleId);
    } else {
      const accessedArticles = Array.isArray(accessedICFArray) && accessedICFArray[0] && accessedICFArray[0].accessed;
      if (Array.isArray(accessedArticles) && accessedArticles.indexOf(articleId) === -1) {
        this.props.setICFAccessArticle(this.props.currentIcfId, articleId);
      }
    }
    this.props.expandFAQContent(articleId, this.props.currentIcfId);
  }

  backToHome() {
    trackLink({ id: 'ICFPage', link: 'icf-articles|back-btn|click', name: 'homePage' });
    this.props.expandFAQContent();
  }

  // Check whether the FAQ item are visited or not
  isVisited(article) {
    if (!article.article_id || !Array.isArray(this.props.accessedList) || !this.props.accessedList.length) {
      return false;
    }

    // Get Accessed FAQ list within current ICF ID
    const accessed = _find(this.props.accessedList, item => item.icfId === this.props.currentIcfId);
    return accessed && Array.isArray(accessed.accessed) && accessed.accessed.indexOf(article.article_id) >= 0;
  }

  // Return Icon style in the CheckBox version style
  renderCheckBoxIconStyle(index, article) {
    // Return index number if the article is not visited
    if (!this.isVisited(article)) {
      return (
        <span className="accordion-guide-article-icon" >
          {index + 1}
        </span>);
    }

    // Return green check icon if the article is visited
    return (
      <span className="accordion-guide-article-icon__visited" >
        {check}
      </span>
    );
  }

  renderArticleList(articles) {
    if (!Array.isArray(articles) || !articles.length) {
      return null;
    }
    return (articles.map((article, index) => (
      <div className={icfArticlesContainer.getGuideArticleContainerStyle(article)}>
        <div className="accordion-guide-article-content">
          {this.renderArticleTitle(article, index)}
          {this.renderArticleContent(article)}
        </div>
      </div>
    )));
  }

  renderArticleTitle(article, index) {
    // Default CheckBox article title style
    return (
      <div // eslint-disable-line jsx-a11y/no-static-element-interactions
        className="accordion-guide-article-header"
        tabIndex="0"
        onClick={() => this.expandHandler(article.article_id)}
        onKeyPress={e => this.keyPressHandler(e, article.article_id)}
      >
        <div className="accordion-guide-article-index" >
          {this.renderCheckBoxIconStyle(index, article)}
        </div>
        <h3 className="accordion-guide-article-title" >
          {article.title}
        </h3>
        <div className="accordion-guide-article-arrow" >
          {this.props.expandedFaqId !== article.article_id ? downArrow : upArrow}
        </div>
      </div>
    );
  }

  renderArticleContent(article) {
    if (this.props.expandedFaqId !== article.article_id) {
      return null;
    }

    return (
      <div // eslint-disable-line jsx-a11y/no-static-element-interactions
        className="accordion-guide-article-body"
        ref={(el) => { this.contentElement = el; }}
        onClick={event => icfArticlesContainer.handleFAQClick(event)}
        onKeyPress={event => icfArticlesContainer.handleKeyPress(event)}
      >
        {Page.getHTMLElement({ message: article.article_content, useHTML: true })}
      </div>);
  }

  renderIcfArticles() {
    const ICFcontent = this.getCurrentICFContent();
    if (!ICFcontent || !ICFcontent.icf_id) {
      return null;
    }

    return (
      <div className="accordion-guide-content">
        <Link to={'/home'} onClick={() => this.backToHome()}>{icf.articles.backBtn}</Link>
        <h2 className="accordion-guide-title">{ICFcontent.icf_title}</h2>
        <div className="accordion-guide-summary">{ICFcontent.icf_summary}</div>
        {this.renderArticleList(ICFcontent.articles)}
      </div>
    );
  }

  render() {
    return this.renderIcfArticles();
  }
}

icfArticlesContainer.propTypes = {
  icfList: PropTypes.arrayOf(PropTypes.shape(shapes.ICF_CONTENT)),
  currentIcfId: PropTypes.string,
  expandFAQContent: PropTypes.func.isRequired,
  expandedFaqId: PropTypes.string,
  setICFAccessArticle: PropTypes.func.isRequired,
  accessedList: PropTypes.arrayOf(PropTypes.shape(shapes.ICF_CONTENT)),
};

icfArticlesContainer.defaultProps = {
  icfList: [],
  accessedList: [],
  expandedFaqId: '',
  currentIcfId: '',
};

function mapStateToProps(state) {
  return {
    icfSelected: state.icfGuide.isIcfSelected,
    icfList: state.icfGuide.icfList,
    currentIcfId: state.icfPage.currentIcfId,
    expandedFaqId: state.icfPage.expandedFaqId,
    accessedList: state.icfPage.accessedList,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ expandFAQContent, setICFAccessArticle }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(icfArticlesContainer);
